import { api } from "..";

const endpoint = "/api/assets";

// GET
export const getAssetList = (queryParams) => {
  return api.get(`${endpoint}`, { params: queryParams });
};

export const getAssetById = (id) => {
  return api.get(`${endpoint}/${id}`);
};

// POST
export const createAsset = (data) => {
  return api.post(`${endpoint}`, data);
};

// PUT
export const updateAsset = (id, data) => {
  return api.put(`${endpoint}/${id}`, data);
};

// DELETE
export const deleteAsset = (id) => {
  return api.delete(`${endpoint}/${id}`);
};
